import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

const DEV = import.meta.env.DEV;

const rootEl = document.getElementById('root');
if (!rootEl) {
  if (DEV) console.error('[main] #root not found');
} else {
  try {
    createRoot(rootEl).render(<HelmetProvider><App /></HelmetProvider>);
    document.body.dataset.appMounted = '1';
  } catch (err) {
    if (DEV) console.error('[main] render error', err);
    (rootEl as HTMLElement).innerText = 'Render error: ' + (err as any)?.message;
  }
}
